/**
 * Assignee group header component
 */

import React from 'react';
import { DragAndDropHandlers } from '../hooks/useDragAndDrop';

export interface AssigneeGroupHeaderProps {
  assignee: string;
  ticketCount: number;
  currentUser?: string;
  isDragOverAssignee: boolean;
  dragHandlers: DragAndDropHandlers;
}

export const AssigneeGroupHeader: React.FC<AssigneeGroupHeaderProps> = ({
  assignee,
  ticketCount,
  currentUser,
  isDragOverAssignee,
  dragHandlers
}) => {
  return (
    <div 
      className={`assignee-group-header ${assignee === currentUser ? 'current-user' : ''} ${
        isDragOverAssignee ? 'drag-over-assignee' : ''
      }`}
      onDragOver={(e) => dragHandlers.handleAssigneeDragOver(e, assignee)}
      onDragLeave={dragHandlers.handleAssigneeDragLeave}
      onDrop={(e) => dragHandlers.handleAssigneeDrop(e, assignee)}
    >
      <h3>
        {assignee === currentUser ? 
          `My Tickets (${ticketCount})` : 
          `Assigned to: ${assignee} (${ticketCount} tickets)`
        }
      </h3>
      {isDragOverAssignee && (
        <div className="drop-indicator">
          Drop ticket here to reassign to {assignee}
        </div>
      )}
    </div>
  );
};